import type { PayloadAction } from "@reduxjs/toolkit";
import { TamperDetection } from "Data/Objects/Camera";
import { createAppSlice } from "Data/Redux/Store";
import type { TamperSettingsState } from "Interfaces";

const initialState: TamperSettingsState = {
	tamperDetection: TamperDetection.OFF
};

// #region reducers

export const setTamperDetectionReducer = (state: TamperSettingsState, action: PayloadAction<TamperDetection>) => {
	if (!action.payload) {
		return;
	}

	state.tamperDetection = action.payload;
};

// #endregion

// #region Selectors

const getTamperDetection = (state: TamperSettingsState) => {
	return state.tamperDetection;
};

// #endregion

const tamperSlice = createAppSlice({
	name: "tamper",
	initialState,
	reducers: {
		setTamperDetectionAction: setTamperDetectionReducer
	},
	selectors: {
		selectTamperDetection: getTamperDetection
	}
});

export default tamperSlice;

export const { setTamperDetectionAction } = tamperSlice.actions;
export const { selectTamperDetection } = tamperSlice.selectors;
